import 'src/App.css';
// import createTheme from "@mui/material/styles/createTheme";
import 'src/assets/css/index.css'
import Grid from "@mui/material/Grid/Grid";
import React, { useRef, useState, lazy} from "react";
// import {styled} from '@mui/material/styles';
// import StepConnector, {stepConnectorClasses} from '@mui/material/StepConnector';

import IPHONE151 from 'src/assets/images/iPhone 15 Pro-1.png';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from 'react-helmet';

import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    // CustomLabelSmallRegular,
} from "src/components/common/CustomLabel";
// import {useMediaQuery} from "@mui/material";
import Box from "@mui/material/Box/Box";
// import Check from '@mui/icons-material/Check';
// import MenuItem from "@mui/material/MenuItem/MenuItem";
import OnDemandDevelopers from "src/components/on-demand-developers";
import FullProjectDevelopment from "src/components/full-project-development";
import ProjectByEquity from "src/components/project-by-equity";
import WhatServices from "src/components/what-services";
import Confirmation from "src/components/confirmation";
import ContactUs from "src/components/contact-us";
// import Intro from "src/components/Intro";
import NavBar from "src/components/nav-bar";
import OurServices from "src/components/our-services";
import SeeOurWork from "src/components/see-our-work";
import ImpactAcrossIndustries from "src/components/impact-across-industries";
import WhatMakeUsDifferent from "src/components/what-make-us-different";
import WhatOurClientSays from "src/components/what-our-client-says";
import MeetOurTeam from "src/components/meet-our-team";
import AboutUs from "src/components/about-us";
import Footer from "src/components/footer";
import TrustedByIndustryLeaders from '../trusted-by-industry-leaders';

const Intro = lazy(() => import("src/components/Intro"));

// import {useNavigate} from "react-router-dom"


// const theme = createTheme({
//     components: {
//         MuiButton: {
//             styleOverrides: {
//                 root: {
//                     boxShadow: 'none',
//                     '&:hover': {
//                         boxShadow: 'none', // Removes hover shadow too
//                     },
//                 },
//             },
//         },
//     },
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 710,
//             md: 950,
//             lg: 1300,
//             xl: 1350,
//         },
//     },
// });


// Carousel settings for react-slick
var settings_our_work = {
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true, 
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    cssEase: "linear",  // Add smooth transition
    swipeToSlide: true, // Enable swipe to slide
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 2,  // Changed from 2.5 to 2
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,  // Changed from 2.5 to 2
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 1,  // Changed from 1.5 to 1
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,  // Changed from 1.2 to 1
                slidesToScroll: 1,
            },
        },
    ],
};


// Carousel settings for react-slick
var settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true, 
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    cssEase: "linear",  // Add smooth transition
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1024, // Large screens
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480, // Mobile
            settings: {
                slidesToShow: 1.2,
            },
        },
    ],
};


// Carousel settings for react-slick
var profile_carousel_settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true, 
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    cssEase: "linear",  // Add smooth transition
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1400, // Large screens
            settings: {
                slidesToShow: 3.5,
            },
        },
        {
            breakpoint: 1200, // Large screens
            settings: {
                slidesToShow: 2.5,
            },
        },
        {
            breakpoint: 1024, // Large screens
            settings: {
                slidesToShow: 2.5,
            },
        },
        {
            breakpoint: 680, // Mobile
            settings: {
                slidesToShow: 1.5,
            },
        },
    ],
};


// const QontoConnector = styled(StepConnector)(({theme}) => ({
//     [`&.${stepConnectorClasses.alternativeLabel}`]: {
//         top: 10,
//         left: 'calc(-50% + 16px)',
//         right: 'calc(50% + 16px)',
//     },
//     [`&.${stepConnectorClasses.active}`]: {
//         [`& .${stepConnectorClasses.line}`]: {
//             borderColor: '#784af4',
//         },
//     },
//     [`&.${stepConnectorClasses.completed}`]: {
//         [`& .${stepConnectorClasses.line}`]: {
//             borderColor: '#784af4',
//         },
//     },
//     [`& .${stepConnectorClasses.line}`]: {
//         borderColor: '#eaeaf0',
//         borderTopWidth: 3,
//         borderRadius: 1,
//         ...theme.applyStyles('dark', {
//             borderColor: theme.palette.grey[800],
//         }),
//     },
// }));

// const QontoStepIconRoot = styled('div')(({theme}) => ({
//     color: '#eaeaf0',
//     display: 'flex',
//     height: 22,
//     alignItems: 'center',
//     '& .QontoStepIcon-completedIcon': {
//         color: '#784af4',
//         zIndex: 1,
//         fontSize: 18,
//     },
//     '& .QontoStepIcon-circle': {
//         width: 8,
//         height: 8,
//         borderRadius: '50%',
//         backgroundColor: 'currentColor',
//     },
//     ...theme.applyStyles('dark', {
//         color: theme.palette.grey[700],
//     }),
//     variants: [
//         {
//             props: ({ownerState}) => ownerState.active,
//             style: {
//                 color: '#784af4',
//             },
//         },
//     ],
// }));

// function QontoStepIcon(props) {
//     const {active, completed, className} = props;

//     return (
//         <QontoStepIconRoot ownerState={{active}} className={className}>
//             {completed ? (
//                 <Check className="QontoStepIcon-completedIcon"/>
//             ) : (
//                 <div className="QontoStepIcon-circle"/>
//             )}
//         </QontoStepIconRoot>
//     );
// }



function Home() {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    // let navigate = useNavigate();

    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const trustedByIndustryLeadersRef = useRef(null);
    const contactUsRef = useRef(null);


    // const steps = ['Basic Info', 'Developer Requirements', 'Addtional Details'];


    // const DeveloperStackListContainer = ["React", "Node js", "Python"].map((list) =>
    //     <MenuItem value={list}><CustomLabelSmallRegular text={list}/></MenuItem>)

    const metaTitle = "Leading mobile app development company in USA - OSTRYX"
    const metaDescription = "OSTRYX is the No.1 passionate mobile app development company in USA. Get USA top mobile app development services for Android and iOS. Let us code your app."
    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>
            <Helmet>
                    <title>{metaTitle}</title>
                    <meta name="url" content="https://ostryx.com" />
                    <link rel="canonical" href="https://ostryx.com" />
                    <meta name="title" content={metaTitle} />
                    <meta name="description" content={metaDescription}/>
                    <meta name="keywords" content="mobile app development USA,
                                                    app development company USA,
                                                    custom mobile apps USA,
                                                    iOS and Android app developers USA
                                                    top app development firms USA,
                                                    USA mobile app developers,
                                                    enterprise app development USA,
                                                    cross-platform app development USA,
                                                    mobile application development company USA,
                                                    best app developers in USA,
                                                    app development services USA,
                                                    mobile software development USA,
                                                    app development agency USA,
                                                    mobile UX/UI design USA,
                                                    app maintenance and support USA," />
                    <meta property="og:title" content={metaTitle} />
                    <meta property="og:description" content={metaDescription} />
                    {/* <meta property="og:image" content="https://www.ostryx.com/assets/icons/FaviconCircle.png" /> */}

                {/* JSON-LD Structured Data */}
                {/* <script type="application/ld+json">
                  {`
                    {
                      "@context": "https://schema.org",
                      "@type": "Corporation",
                      "name": "OSTRYX",
                      "alternateName": "OSTRYX USA",
                      "url": "https://ostryx.com/",
                      "image": "https://ostryx.com/images/ostryx-lap.png",
                      "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+1(850)586-1700",
                        "contactType": "customer service",
                        "contactOption": "TollFree",
                        "areaServed": "US",
                        "availableLanguage": "en"
                      },
                      "sameAs": [
                        "https://www.instagram.com/ostryxsolutions/",
                        "https://www.linkedin.com/company/ostryx/"
                      ],
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Southwinds Drive Destin, FL 32550 United States.",
                        "addressLocality": "Destin, Florida",
                        "addressRegion": "United state",
                        "addressCountry": "US",
                        "postalCode": "32540",
                        "telephone": "+1(850)586-1700"
                      }
                    }
                  `}
                </script>
                <script type="application/ld+json">
                  {`
                    {
                      "@context": "https://schema.org",
                      "@type": "WebSite",
                      "url": "https://ostryx.com",
                      "name": "Leading Mobile App Development Company in USA - OSTRYX",
                      "potentialAction": {
                        "@type": "SearchAction",
                        "target": {
                          "@type": "EntryPoint",
                          "urlTemplate": "https://ostryx.com{search_term_string}"
                        },
                        "query-input": "required name=search_term_string"
                      },
                      "keywords": "mobile app development USA, app development USA, app development company USA, ios development USA, ios app development Destin FL, android development USA, android app development Florida, app design USA, mobile application development Florida, mobile app design USA, android application development USA, app development agency USA, best application development company in USA, top app development Florida, mobile app development company USA,"
                    }
                  `}
                </script>
                <script type="application/ld+json">
                  {`
                    {
                      "@context": "http://schema.org/",
                      "@type": "Product",
                      "name": "Mobile App Development Company USA",
                      "image": "https://ostryx.com/images/ostryx-lap.png",
                      "brand": "OSTRYX",
                      "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "5",
                        "ratingCount": "1",
                        "bestRating": "5",
                        "worstRating": "1"
                      },
                      "description": "OSTRYX is the No.1 passionate mobile app development company in USA. Get USA top mobile app development services for Android and iOS. Let us code your app."
                    }
                  `}
                </script>
                <script type="application/ld+json">
                  {`
                    {
                      "@context": "https://schema.org/",
                      "@type": "BreadcrumbList",
                      "itemListElement": [
                        {
                          "@type": "ListItem",
                          "position": 1,
                          "name": "Mobile app development company USA",
                          "item": "https://ostryx.com/"
                        },
                        {
                          "@type": "ListItem",
                          "position": 2,
                          "name": "Mobile App Development Florida",
                          "item": "https://ostryx.com/mobile-app-development"
                        }
                      ]
                    }
                  `}
                </script>
                <script type="application/ld+json">
                  {`
                    {
                      "@context": "https://schema.org/",
                      "@type": "Service",
                      "name": "Mobile App Development Company in USA",
                      "description": "OSTRYX is the No.1 passionate mobile app development company in USA. Get USA top mobile app development services for Android and iOS. Let us code your app.",
                      "serviceType": "Mobile App Development",
                      "provider": {
                        "@type": "Organization",
                        "name": "OSTRYX",
                        "url": "https://ostryx.com/",
                        "logo": "https://ostryx.com/images/logo-with-text.png"
                      },
                      "areaServed": "United State",
                      "offers": {
                        "@type": "Offer",
                        "price": "$$$$",
                        "priceCurrency": "USTD",
                        "availability": "https://schema.org/InStock"
                      },
                      "image": "https://ostryx.com/images/ostryx-lap.png"
                    }
                  `}
                </script>
                <script type="application/ld+json">
                  {`
                    [
                      {
                        "@context": "https://schema.org/",
                        "@type": "SiteNavigationElement",
                        "name": "Home",
                        "url": "https://ostryx.com/"
                      },
                      {
                        "@context": "https://schema.org/",
                        "@type": "SiteNavigationElement",
                        "name": "web App Developers",
                        "url": "https://ostryx.com/web-app-development"
                      },
                      {
                        "@context": "https://schema.org/",
                        "@type": "SiteNavigationElement",
                        "name": "Contact",
                        "url": "https://ostryx.com/contact-us"
                      }
                    ]
                  `}
                </script> */}
            </Helmet>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                    testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                    contactUsRef={contactUsRef}
                    trustedByIndustryLeadersRef={trustedByIndustryLeadersRef}
                    setShowWhatService={setShowWhatService}/>


            <Intro setShowWhatService={setShowWhatService}/>

            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <SeeOurWork portfolioRef={portfolioRef} settings_our_work={settings_our_work}/>

            <TrustedByIndustryLeaders trustedByIndustryLeadersRef={trustedByIndustryLeadersRef} setShowWhatService={setShowWhatService} />

            <ImpactAcrossIndustries partnersRef={partnersRef}/>


            <WhatMakeUsDifferent setShowWhatService={setShowWhatService}/>


            <WhatOurClientSays testimonalsRef={testimonalsRef} settings={settings}/>


            <MeetOurTeam profile_carousel_settings={profile_carousel_settings}/>


            <AboutUs/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}, px :{ xs: 1, md: 5}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions. "}
                    />
                </Grid>


                <Grid item container xs={12} justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8} sx={{ padding: "0px" }}>
                        <Box 
                            component="img" 
                            src={IPHONE151} 
                            alt="OSTRYX" 
                            sx={{ 
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                                maxHeight: "600px",
                                borderRadius: "25px"
                            }}
                        />
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>

        </Grid>
    );
}

export default Home;


